export default "__VITE_ASSET__DNQNqjgK__"